import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';

const ActionsList = ({ cell }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      navigate({
        pathname: '/sportello/registrazione-carta/registra',
        search: `?${createSearchParams({
          codiceFiscale: cell?.fiscalCode || '',
          nome: cell?.name || '',
          cognome: cell?.surname || '',
          stato: cell?.statePerson || '',
          idSchedaSoggettoANPR: cell?.anpr || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Modifica elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - residency permit page component';

export default ActionsList;
